import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchAdminProfile, fetchProfile } from "../../../store/slices/profileSlice";
import UploadErrorBanner from "../../../pages/CitizenshipReimbursement/UploadDocument/ViewDetails/UploadErrorBanner";

const AdminRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isAdmin, adminProfile, loading, error } = useAppSelector(
    (state) => state.profile
  );

  useEffect(() => {
    if (adminProfile === null && !loading && !error) {
      dispatch(fetchAdminProfile());
      dispatch(fetchProfile());
    }
  }, [dispatch, adminProfile, loading, error]);

  // ==================== LOADING STATE ====================
  if (adminProfile === null || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-lg font-medium text-gray-700">
          Checking admin access...
        </p>
      </div>
    );
  }

  // ==================== ERROR STATE ====================
  if (error && !adminProfile) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <UploadErrorBanner
          header="Unable to Load Admin Profile"
          message={error}
          className="w-full max-w-md"
        />
      </div>
    );
  }

  // ==================== UNAUTHORIZED STATE ====================
  if (adminProfile && !isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center text-center">
        <div>
          <p className="text-lg font-medium text-red-600">
            You are not authorized to access this page.
          </p>
        </div>
      </div>
    );
  }

  // ==================== AUTHORIZED STATE ====================
  return <Outlet />;
};

export default AdminRoute;